"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-1eu55v9-0"
})(["background:", ";color:", ";display:flex;flex-direction:column;position:fixed;inline-size:100%;block-size:100%;top:0;left:0;z-index:", ";overflow-wrap:break-word;"], function (props) {
  return "var(--background-base, ".concat(_index.defaultTheme[props.$colorSet].background.base, ")");
}, function (props) {
  return "var(--text-base, ".concat(_index.defaultTheme[props.$colorSet].text.base, ")");
}, _index.zIndexDialog);